import React, { useState } from 'react';
import { GENRE_LIBRARY } from '../data/GenreLibrary';

const DNAModal = ({ isOpen, onClose, traitOverrides, setTraitOverride }) => {
    if (!isOpen) return null;

    // Flatten all subgenres
    const allStyles = [];
    Object.keys(GENRE_LIBRARY).forEach(ensKey => {
        const ens = GENRE_LIBRARY[ensKey];
        Object.keys(ens.subGenres).forEach(subKey => {
            allStyles.push({
                value: subKey,
                label: ens.subGenres[subKey].name,
                ensemble: ens.name
            });
        });
    });

    const categories = [
        { key: 'harmony', label: 'Harmony DNA' },
        { key: 'rhythm', label: 'Rhythm DNA' },
        { key: 'voicing', label: 'Voicing DNA' }
    ];

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 2000,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            backdropFilter: 'blur(5px)'
        }}>
            <div className="panel" style={{
                width: '90%', maxWidth: '1000px', height: '80vh',
                display: 'flex', flexDirection: 'column',
                boxShadow: '0 0 40px rgba(0,0,0,0.8)'
            }}>
                <div style={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    borderBottom: '1px solid #333', paddingBottom: '15px', marginBottom: '20px'
                }}>
                    <h2 style={{ margin: 0 }}>DNA Editor</h2>
                    <button onClick={onClose} style={{ border: 'none', background: 'transparent', fontSize: '1.5rem', cursor: 'pointer' }}>×</button>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '20px', overflowY: 'auto', flex: 1 }}>
                    {categories.map(cat => (
                        <div key={cat.key} style={{ display: 'flex', flexDirection: 'column' }}>
                            <h3 style={{ fontSize: '1rem', color: 'var(--color-primary)', borderBottom: '1px solid #333', paddingBottom: '5px' }}>{cat.label}</h3>

                            <button
                                onClick={() => setTraitOverride(cat.key, 'match')}
                                style={{
                                    marginTop: '10px',
                                    marginBottom: '10px',
                                    backgroundColor: traitOverrides[cat.key] === null ? 'var(--color-primary-dim)' : '#222',
                                    border: traitOverrides[cat.key] === null ? '1px solid var(--color-primary)' : '1px solid #333',
                                    color: traitOverrides[cat.key] === null ? 'var(--color-primary)' : '#888'
                                }}
                            >
                                Match Base Genre
                            </button>

                            <div style={{ display: 'grid', gap: '5px' }}>
                                {allStyles.map(s => {
                                    const isActive = traitOverrides[cat.key] === s.value;
                                    return (
                                        <button
                                            key={s.value}
                                            onClick={() => setTraitOverride(cat.key, s.value)}
                                            style={{
                                                textAlign: 'left',
                                                fontSize: '0.8rem',
                                                padding: '8px',
                                                backgroundColor: isActive ? 'var(--color-secondary)' : '#111',
                                                color: isActive ? '#000' : '#ccc',
                                                border: '1px solid #333',
                                                opacity: isActive ? 1 : 0.7
                                            }}
                                        >
                                            <span style={{ fontWeight: 'bold' }}>{s.label}</span>
                                            <span style={{ display: 'block', fontSize: '0.6rem', opacity: 0.7 }}>{s.ensemble}</span>
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                </div>

                <div style={{ marginTop: '20px', textAlign: 'right' }}>
                    <button onClick={onClose} style={{ borderColor: 'var(--color-primary)', color: 'var(--color-primary)' }}>DONE</button>
                </div>
            </div>
        </div>
    );
};

export default DNAModal;
